export default function ValueSection({ image = "nestroot-value-table.png" }: { image?: string }) {
  return (
    <section className="tw-bg-white tw-text-black">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
        <div className="tw-flex tw-items-center tw-px-6 tw-py-20 md:tw-px-20 md:tw-py-0 md:tw-min-h-[600px]">
          <div className="tw-max-w-xl">
            <h2 
              className="tw-text-4xl md:tw-text-5xl tw-font-medium tw-leading-tight tw-text-black tw-mb-8"
              style={{ fontFamily: "'Instrument Serif', serif" }}
            >
              You depend on your product, keep it safe for the long-haul.
            </h2>

            <p 
              className="tw-text-gray-700 tw-text-lg md:tw-text-xl tw-leading-relaxed"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Peace of mind shouldn&apos;t end when your warranty does. 
              Thanks to the Nestroots Care Plan, it doesn&apos;t have to. 
              You&apos;ll enjoy protection beyond your manufacturer&apos;s warranty.
            </p>
          </div>
        </div>

        <div className="tw-relative tw-h-[400px] md:tw-h-auto md:tw-min-h-[600px]">
          <img
            src={`/nestroot/${image}`}
            alt="Nestroots Furniture Care"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
          />
        </div>
      </div>
    </section>
  );
}
